import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PlusCircleIcon from 'react-icons/lib/fa/plus-circle';

import Styles from './styles';
import UserAvatar from '../UserAvatar';
import Button from '../UIKit/Button';
import ListItem from '../SelectableListItem';
import Label from '../UIKit/Label';
import Hr from '../UIKit/Hr';
import Spacer from '../Spacer';
import SortableList from '../SortableList';

const UserDrawer = (props) => {
  const organizations = props.organizations.map((item) => {
    const organization = item;
    organization.text = item.name;
    organization.id = item.key;
    organization.icon = 'icon-organization';
    return organization;
  });

  return (
    <div style={Styles.wrapper}>
      <div style={Styles.userWrapper}>
        <div style={Styles.nameWrapper}>
          <p style={Styles.displayName}>{props.profile.displayName}</p>
          <p style={Styles.organization}>Horizon New Media</p>
        </div>
        <UserAvatar size={70} src={props.profile.avatarUrl} />
      </div>
      <div style={Styles.organizationsWrapper}>
        <Link style={{ color: 'inherit' }} to="/organizations">
          <Label style={{ padding: 10 }}>Organizations</Label>
        </Link>
        <SortableList
          selected={props.currentOrganization}
          items={organizations}
          onItemClick={props.onOrganizationClick}
        />
        <Link style={{ color: 'inherit' }} to="/create-organization">
          <Button onClick={props.onOrganizationCreateClick} size="sm" style={Styles.addButton}>
            <PlusCircleIcon size={17} />
          </Button>
        </Link>
      </div>
      <Hr />
      <div style={Styles.settingsWrapper}>
        <Label style={{ padding: 10 }}>User profile</Label>
        <ListItem>
          <Link style={{ color: 'inherit' }} to="/settings">
            Account Settings
          </Link>
        </ListItem>
      </div>
      <Spacer />
      <Button style={Styles.logoutButton} onClick={props.onLogoutClick}>
        LOGOUT
      </Button>
    </div>
  );
};

UserDrawer.propTypes = {
  currentOrganization: PropTypes.string,
  profile: PropTypes.object,
  organizations: PropTypes.array,
  onOrganizationClick: PropTypes.func,
  onOrganizationCreateClick: PropTypes.func,
  onLogoutClick: PropTypes.func,
};

UserDrawer.defaultProps = {
  currentOrganization: '',
  profile: null,
  organizations: [],
  onOrganizationClick: () => {},
  onOrganizationCreateClick: () => {},
  onLogoutClick: () => {},
};

export default UserDrawer;



// WEBPACK FOOTER //
// ./src/components/UserDrawer/index.js